import {Order} from './order.class';
import {SpecialOrder, validOrderRegexString} from './order.types';
import {User} from '../users/user.class';

/**
 * Returns desired "Proceed to Checkout" button name
 * @param user
 * @param order
 */
export const getProceedToCheckoutButtonName = (user: User, order: Order) => {
    if (user.isPunchout) {
        return `Submit Basket to ${user.punchoutAppName}`;
    }
    if (order.punchIn) {
        return `Submit To Amerit Buyer`;
    }
    return `Proceed to Checkout`;
};

/**
 * Returns name of special order based on attributes
 * @param specialOrder
 */
export const getSpecialOrderName = (specialOrder: SpecialOrder) => {
    if (specialOrder.nonstockOrdr) {
        return `Special Order`;
    }
    if (specialOrder.automatic) {
        return `Back Order`;
    }
    return `Hold For Inventory`;
};

/**
 * Returns true if provided addressString is a PO Box
 * @param addressString - Address string to test
 */
export const isPoBox = (addressString: string) => {
    if (addressString) {
        const isPoBoxRegex = /^(((p[\s.]?[o\s][.]?)\s?)|(post\s?office\s?))((box|bin|b\.?)?\s?(num|number|#)?\s?\d+)/i;
        return isPoBoxRegex.test(addressString);
    }

    // Falsy values are not a PO Box
    return false;
};

/**
 * Returns true if provided addressString is a private mailbox (PMB)
 * @param addressString - Address string to test
 */
export const isPrivateMailbox = (addressString: string) => {
    if (addressString) {
        const isPMBRegex = /PMB#*\s*#*\d+/i;
        return isPMBRegex.test(addressString);
    }

    // Falsy values are not a private mailbox
    return false;
};

/**
 * Tests validity of order number
 * @param ordrNbr
 */
export const isValidOrderNumber = (ordrNbr: string) => {
    const validOrderRegex = new RegExp(`^${validOrderRegexString}$`, `i`);
    return validOrderRegex.test(ordrNbr);
};
